import { useState, useEffect, useRef } from "react";
import { Modal } from "../components/Modal.jsx";
import { casualData } from "../api/casualData.js";

function resultLabel(result) {
  return result.columns.map(c => result.cells?.[c.id]).filter(Boolean).join(" · ") || "(be reikšmių)";
}

// Kainininko produkto paieška Duomenų matricos eilutės "gyvam susiejimui" —
// tas pats precedentas kaip RowSuppliersModal.jsx. Paieška per VISŲ
// Kainininko lentelių eilučių reikšmes (žr. kainininkas/routes.ts), ne
// vien vienos lentelės, nes gamintojų/lentelių jau yra daug.
export function KainininkasLinkModal({ rowLabel, currentSource, onClose, onSelect }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    const query = q.trim();
    if (!query) { setResults([]); setLoading(false); return; }
    setLoading(true);
    debounceRef.current = setTimeout(() => {
      casualData.searchKainininkasRows(query)
        .then(data => setResults(data?.results || []))
        .catch(e => console.error("Failed to search kainininkas rows", e))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(debounceRef.current);
  }, [q]);

  return (
    <Modal title={`Susieti su Kainininku: ${rowLabel || "(be pavadinimo)"}`} onClose={onClose}>
      {currentSource && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#f3f4f6", borderRadius: 8, padding: "8px 12px", marginBottom: 12 }}>
          <div style={{ fontSize: 13 }}>
            <span style={{ color: "#9ca3af" }}>Susieta su: </span>
            <span style={{ fontWeight: 700, color: "#1c1c1c" }}>{currentSource.manufacturerName} / {currentSource.groupName}</span>
          </div>
          <button onClick={() => onSelect(null)}
            style={{ background: "#fff", color: "#b45309", border: "1px solid #e5e7eb", borderRadius: 6, padding: "4px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
            Atsieti
          </button>
        </div>
      )}
      <input value={q} onChange={e => setQ(e.target.value)} autoFocus placeholder="Ieškoti produkto (kodas, matmenys...)"
        style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 13, boxSizing: "border-box", marginBottom: 10 }} />
      {loading && <p style={{ fontSize: 12, color: "#9ca3af" }}>Ieškoma...</p>}
      {!loading && q.trim() && results.length === 0 && <p style={{ fontSize: 12, color: "#9ca3af" }}>Nerasta.</p>}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 360, overflowY: "auto" }}>
        {results.map(r => (
          <button key={r.rowId} onClick={() => onSelect(r.rowId)}
            style={{ textAlign: "left", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", cursor: "pointer" }}>
            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>{r.manufacturerName} / {r.groupName} / {r.tableName}</div>
            <div style={{ fontSize: 13, color: "#1c1c1c" }}>{resultLabel(r)}</div>
          </button>
        ))}
      </div>
    </Modal>
  );
}
